import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio as MuiRadio,
  RadioGroupProps as MuiRadioGroupProps,
  RadioGroup
} from '@mui/material';
import { FormFieldApi } from '../types';

export interface RadioOption {
  value: string;
  label: string;
}

export interface RadioProps extends Omit<MuiRadioGroupProps, 'name' | 'onChange' | 'onBlur' | 'value'> {
  field: FormFieldApi<string>;
  name: string;
  label: string;
  options: RadioOption[];
  helperText?: string;
  required?: boolean;
}

/**
 * Radio component that integrates with form handling
 */
export const Radio = ({
  field,
  name,
  label,
  options,
  helperText,
  required,
  ...props
}: RadioProps) => {
  const { state, getMeta } = field;
  const meta = getMeta();
  const error = meta.touchedErrors.length > 0;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    field.handleChange(event.target.value);
  };

  return (
    <FormControl required={required} error={error} variant="standard" fullWidth>
      <FormLabel id={`${name}-label`}>{label}</FormLabel>
      <RadioGroup
        aria-labelledby={`${name}-label`}
        name={name}
        value={state.value}
        onChange={handleChange}
        {...props}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<MuiRadio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      {(helperText || error) && (
        <FormHelperText>
          {error ? meta.touchedErrors[0] : helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}; 